export const extractVideoId = (url: string) => {
  const patterns = [
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,
    /^.*(youtube.com\/live\/)([^#\&\?]*).*/
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[2].length >= 11) {
      return match[2];
    }
  }
  return null;
};

export const isValidYoutubeUrl = (url: string) => {
  if (!url) return false;
  const videoId = extractVideoId(url);
  return videoId !== null;
};